import React from 'react';
import { getGroup, searchGroup } from '../../../../../helpers/group-helper';
import { usePaginatedSearchList } from '../../../../../hooks/usePaginatedSearchList';
import { mapGroupForList } from '../helpers';

export const useGroupListScreen = ({ token }) => {
    const {
        items: groups,
        isLoading,
        error,
        pagination,
        searchTerm,
        searchField,
        statusFilter,
        rowsPerPage,
        setOffset,
        handleRowsPerPageChange,
        handleSearchTermChange,
        handleSearchFieldChange,
        handleStatusFilterChange,
        handleClearFilters,
    } = usePaginatedSearchList({
        token,
        getItems: getGroup,
        searchItems: searchGroup,
        initialSearchField: 'code',
        initialStatusFilter: 'ALL',
        initialRowsPerPage: 10,
        debounceMs: 600,
    });

    const mappedGroups = React.useMemo(() => {
        return (Array.isArray(groups) ? groups : []).map((group) => mapGroupForList(group));
    }, [groups]);

    return {
        mappedGroups,
        isLoading,
        error,
        pagination,
        searchTerm,
        searchField,
        statusFilter,
        rowsPerPage,
        setOffset,
        handleRowsPerPageChange,
        handleSearchTermChange,
        handleSearchFieldChange,
        handleStatusFilterChange,
        handleClearFilters,
    };
};
